import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { handleChange, handleSubmit } from "../../Controller/CreateCommunicationController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';
import Draggable from 'react-draggable';
import EmailPreviewModal from '../../../Common/EmailPreviewModal';
import LeadDiariesModal from './LeadDiaries';
import UserService from "../../../Setup/controller/UserController/UserController";
import SunTextEditor from "../../../Common/SunTextEditor";
import DocumentService from "../../../Setup/controller/DocumentController/DocumentController";
import BASE_URL from "../../../../config/config";
import { useDropzone } from 'react-dropzone';
import Swal from 'sweetalert2';
function CreateCommunication({ modalInstance, currentCommunicationHistory, onClose, onSuccess, LeadID, IsDiaries, CommunicationID, Phone, Mobile, CompanyName, ToEmail }) {

    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = theme === "dark" ? "accordion-header-dark" : "accordion-header-light";
    const getCurrentDate = () => {
        const today = new Date();
        return today.toISOString().split('T')[0];
    };
    const getCurrentTime = (addHour = 0) => {
        const now = new Date();
        now.setHours(now.getHours() + addHour); // Add hours dynamically
        return now.toTimeString().split(' ')[0].slice(0, 5); // Format HH:MM
    };
    const addOneDay = (dateStr) => {
        const date = new Date(dateStr);
        date.setDate(date.getDate() + 0);
        return date.toISOString().split('T')[0];
    };
    const ClientID = localStorage.getItem('CompanyID');
    const [formData, setFormData] = useState({
        ID: 0, Lead_ID: LeadID, Opportunity_ID: '0', dt_Created: getCurrentDate(),
        snt_CommunicationType: currentCommunicationHistory?.snt_CommunicationType?.toString() || '0'
        , vc_Subject: '', vc_Description: '',
        vc_From: localStorage.getItem('Email'), vc_To: ToEmail, vc_CC: '',
        AppointmentDate: new Date(getCurrentDate()).toISOString().split('T')[0], StartTime: getCurrentTime(), Completed: 0,
        DueDate: getCurrentDate(), DueTime: getCurrentTime(),
        AppointmentEndDate: getCurrentDate(), AppointmentEndTime: getCurrentTime(1),
        EmailFooter: localStorage.getItem('EmailFooter'),
        AssignUserID: localStorage.getItem('UserID'),
        Status: "0", IsEmailSend: "1", CompanyDocument: 0,
        Name: "", Description: "",
        FileName: '', Path: '', File: null
    });
    const [todos, setTodos] = useState([]);
    const [todoInput, setTodoInput] = useState("");
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const [showEmailPreview, setShowEmailPreview] = useState(false);
    const [showDiaryModal, setShowDiaryModal] = useState(false);
    const [userList, setUserList] = useState([]);
    const [loading, setLoading] = useState(false);
    const fetchAllUsers = async () => {
        try {
            const redirectCallback = () => navigate('/');
            const usersData = await UserService.getAllUsers(redirectCallback);
            setUserList(usersData);
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };
    useEffect(() => {

        fetchAllUsers();
        fetchDocument();
        if (currentCommunicationHistory) {

            const formattedDate = currentCommunicationHistory.dt_Created ? currentCommunicationHistory.dt_Created.slice(0, 10) : '';

            if (currentCommunicationHistory.FileName) {
                const fileUrl = `${BASE_URL}/uploads/${ClientID}/Lead/Communication/${currentCommunicationHistory.FileName}`;

                setPdfAttachment({
                    url: fileUrl,
                    name: currentCommunicationHistory.FileName,
                    file: null // no file object yet
                });
            } else {
                setPdfAttachment(null);
            }



            const AppointmentDate = currentCommunicationHistory.AppointmentDate ? currentCommunicationHistory.AppointmentDate.slice(0, 10) : '';
            const DueDate = currentCommunicationHistory.DueDate ? currentCommunicationHistory.DueDate.slice(0, 10) : '';
            const AppointmentEndDate = currentCommunicationHistory.AppointmentEndDate ? currentCommunicationHistory.AppointmentEndDate.slice(0, 10) : '';
            setFormData({
                ID: currentCommunicationHistory.ID,
                Lead_ID: LeadID,
                snt_CommunicationType: currentCommunicationHistory.snt_CommunicationType.toString(),
                vc_Description: currentCommunicationHistory.vc_Description,
                dt_Created: formattedDate,
                vc_Subject: currentCommunicationHistory.vc_Subject,
                vc_From: currentCommunicationHistory.vc_From ?? localStorage.getItem('Email'),
                vc_To: currentCommunicationHistory.vc_To,
                vc_CC: currentCommunicationHistory.vc_CC,
                AppointmentDate: AppointmentDate,
                StartTime: currentCommunicationHistory.StartTime,
                Completed: parseInt(currentCommunicationHistory.Completed),
                DueDate: DueDate,
                DueTime: currentCommunicationHistory.DueTime,
                AppointmentEndDate: AppointmentEndDate,
                AppointmentEndTime: currentCommunicationHistory.EndTime,
                AssignUserID: currentCommunicationHistory.AssignUserID,
                EmailFooter: localStorage.getItem('EmailFooter'),
                Status: currentCommunicationHistory.Status,
                CompanyDocument: 0,
                Name: "",
                Description: "",
                FileName: currentCommunicationHistory.FileName,
                File: null,
                Path: currentCommunicationHistory.Path,
            });
        }
        else {

            setFormData({

                ID: 0, Lead_ID: LeadID, Opportunity_ID: '0', dt_Created: getCurrentDate(),
                snt_CommunicationType: currentCommunicationHistory?.snt_CommunicationType?.toString() || '0',
                vc_Subject: '', vc_Description: '', vc_From: localStorage.getItem('Email'),
                vc_To: ToEmail, vc_CC: '',
                AppointmentDate: new Date(getCurrentDate()).toISOString().split('T')[0], StartTime: getCurrentTime(), Completed: 0,
                DueDate: new Date(getCurrentDate()).toISOString().split('T')[0],
                DueTime: getCurrentTime(),
                AppointmentEndDate: new Date(getCurrentDate()).toISOString().split('T')[0],
                AppointmentEndTime: getCurrentTime(1), EmailFooter: localStorage.getItem('EmailFooter'),
                AssignUserID: localStorage.getItem('UserID'),
                Status: "0",
                IsEmailSend: "1", CompanyDocument: 0,
                Name: "",
                Description: "",
                FileName: "",
                File: null,
                Path: ""
            });
        }
    }, [currentCommunicationHistory]);

    const handleFieldChange = async (event) => {
        const { name, value } = event.target;

        if (name === "CompanyDocument") {
            const doc = DocuemntList.find(
                x => x.ID.toString() === value.toString()
            );

            if (doc) {
                try {
                    const fileUrl = `${BASE_URL}/uploads/${ClientID}/Admin/Documents/${doc.FileName}`;

                    // 🔥 Convert URL → File
                    const response = await fetch(fileUrl);
                    const blob = await response.blob();
                    const file = new File([blob], doc.FileName, { type: blob.type });

                    // ✅ Store actual file
                    setPdfAttachment({
                        file: file,          // ✅ for email
                        url: fileUrl,        // ✅ for download
                        name: doc.DocumentName
                    });

                    setFormData(prevState => ({
                        ...prevState,
                        [name]: value,
                        Name: doc.DocumentName || "",
                        Description: doc.Description || "",
                        FileName: doc.FileName || ""
                    }));

                } catch (err) {
                    console.error("Error fetching file:", err);
                }

            } else {
                // Reset if "New Document"
                setPdfAttachment(null);

                setFormData(prevState => ({
                    ...prevState,
                    [name]: value,
                    Name: "",
                    Description: "",
                    FileName: ""
                }));
            }
        } else {
            handleChange(event, formData, setFormData);
        }
    };

    const handleEditorChange = (content) => {
        setFormData({
            ...formData,
            vc_Description: content
        });
    };

    const handleRadioChange = (event) => {
        const { value } = event.target;
        setFormData({
            ...formData,
            snt_CommunicationType: value
        });
    };

    const handleFormSubmit = async (event) => {
        try {
            event.preventDefault();
            setLoading(true);
            if (currentCommunicationHistory) {
                formData.ID = currentCommunicationHistory.ID;
            } else {
                formData.ID = 0;
            }

            /*  if (formData.snt_CommunicationType === '2') {
                  // Check Dates
                  if (new Date(formData.DueDate) <= new Date(formData.dt_Created)) {
                      setErrors({ DueDate: 'Due Date must be greater than Date' });
                      return;
                  }
              }*/
            if (formData.snt_CommunicationType === '3') {
                // Check Dates
                /* if (new Date(formData.AppointmentDate) <= new Date(formData.dt_Created)) {
                     setErrors({ AppointmentDate: 'Appointment Date must be greater than Date' });
                     return;
                 }*/
                if (formData.StartTime && formData.AppointmentEndTime) {
                    const startTime = new Date(`1970-01-01T${formData.StartTime}`);
                    const endTime = new Date(`1970-01-01T${formData.AppointmentEndTime}`);

                    if (endTime <= startTime) {
                        setErrors({ AppointmentEndTime: 'End Time must be greater than Start Time' });
                    }
                }
            }
            if (formData.snt_CommunicationType==="1" && formData.vc_From != localStorage.getItem('Email')) {
                Swal.fire(
                    'Error!',
                    'You are not authorized to send this email. Please use your registered account to continue.',
                    'error'
                );
                return false;
            }
            const postData = await handleSubmit(event, formData, setFormData, setErrors, pdfAttachment);
            if (postData && postData.data.message === "User added successfully") {
                localStorage.setItem('HasRecordUpdated', "1");
                setLoading(false);
                onSuccess();
                onClose();
            }
        }
        catch (error) {
            console.error('Error fetching Roles:', error);
            setLoading(false);
        }
        finally {
            setLoading(false);
        }
    };

    const handleStart = (e, ui) => {
        e.stopPropagation();
    };

    // ToDo handlers
    const handleAddTodo = () => {
        if (todoInput.trim() !== "") {
            setTodos([...todos, { id: Date.now(), text: todoInput, completed: false }]);
            setTodoInput("");
        }
    };

    const handleToggleTodo = (id) => {
        setTodos(todos.map(todo =>
            todo.id === id ? { ...todo, completed: !todo.completed } : todo
        ));
    };

    const handleDeleteTodo = (id) => {
        setTodos(todos.filter(todo => todo.id !== id));
    };
    const handleSuccess = async (DueDate, StartTime, EndTime, AssignUserID) => {

        if (formData.snt_CommunicationType.toString() === "2") {
            setFormData({
                ...formData,
                DueDate: DueDate,
                DueTime: StartTime,
                AssignUserID: AssignUserID
            });
        }
        else if (formData.snt_CommunicationType.toString() === "3") {
            setFormData({
                ...formData,
                AppointmentDate: DueDate,
                StartTime: StartTime,
                AppointmentEndTime: EndTime,
                AssignUserID: AssignUserID
            });
        }
        setShowDiaryModal(false);
    };


    const [pdfAttachment, setPdfAttachment] = useState(null);
    const [DocuemntList, setDocumentList] = useState([]);
    const fetchDocument = async (ModuleID) => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const list = await DocumentService.GetDocuments(redirectCallback, "17");
            setDocumentList(list);
        } catch (error) {
            console.error('Error fetching Project Members:', error);
        }
    };
    const onDrop = (acceptedFiles) => {
        const file = acceptedFiles[0];
        if (file) {
            setFormData(prevState => ({
                ...prevState,
                File: file,
                Path: file.name
            }));
        }
    };
    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });
    return (
        <div>
            {loading && (
                <div class="loading" style={{ zIndex: "10000" }}>
                    <div class="d-table">
                        <div class="d-tablecell">
                            <span class="loader">
                                <span class="loader-inner"></span>
                            </span>
                        </div>
                    </div>
                </div>
            )}
            <form onSubmit={handleFormSubmit}>

                <div className="modal fade customerHistoryModal show d-block" id="customerHistoryModal" tabIndex="-1" aria-labelledby="customerHistoryModalLabel">

                    <div className="modal-dialog modal-lg" style={{ width: "75%", "left": "6vh", top: "2vh" }}>
                        <Draggable handle=".modal-header" onStart={handleStart}
                            bounds={{ top: -40, bottom: window.innerHeight - 400 }}
                            cancel="input, textarea, select, button">
                            <div className="modal-content">
                                <div className={`modal-header ${accordTheme}`}>
                                    <h5 className="modal-title" id="largeModalLabel">{currentCommunicationHistory ? "Edit Communication" : "Add Communication"} </h5> {(IsDiaries === "1" && <strong style={{ marginLeft: "10px", marginTop: "1px" }}>  ({CompanyName})  </strong>)}
                                    <button type="button" className="close" aria-label="Close" onClick={onClose}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="row mb-3" style={{ marginRight: "10px" }}>
                                        <table style={{ width: "100%" }}>
                                            <tbody>
                                                <tr>
                                                    <td style={{ width: "13%" }}>
                                                        <label htmlFor="Description" style={{ float: "right" }}>Select Type &nbsp;&nbsp;</label>
                                                    </td>
                                                    <td style={{ width: "37%" }}>
                                                        <table style={{ width: "100%" }}>
                                                            <tr>
                                                                <td style={{ width: "1%" }}>

                                                                    <input style={{ marginLeft: "5px", marginBottom: "10px" }} type="radio" name="snt_CommunicationType" value="0" checked={formData.snt_CommunicationType === '0'}
                                                                        onChange={handleRadioChange}
                                                                    />

                                                                </td>
                                                                <td style={{ width: "10%" }}>
                                                                    <label>Notes</label>
                                                                </td>

                                                                <td style={{ width: "1%" }}>
                                                                    <input type="radio" style={{ marginLeft: "5px", marginBottom: "10px" }} name="snt_CommunicationType" value="1" checked={formData.snt_CommunicationType === '1'}
                                                                        onChange={handleRadioChange}
                                                                    />

                                                                </td>
                                                                <td style={{ width: "10%" }}>
                                                                    <label>Email</label>
                                                                </td>

                                                                <td style={{ width: "1%" }}>
                                                                    <input type="radio" style={{ marginBottom: "10px", marginLeft: "5px" }} name="snt_CommunicationType" value="2" checked={formData.snt_CommunicationType === '2'}
                                                                        onChange={handleRadioChange}
                                                                    />

                                                                </td>
                                                                <td style={{ width: "10%" }}>
                                                                    <label>Task</label>
                                                                </td>

                                                                <td style={{ width: "1%" }}>
                                                                    <input type="radio" style={{ marginBottom: "10px", marginLeft: "5px" }} name="snt_CommunicationType" value="3" checked={formData.snt_CommunicationType === '3'}
                                                                        onChange={handleRadioChange}

                                                                    />

                                                                </td>
                                                                <td style={{ width: "10%" }}>
                                                                    <label>Appointment</label>
                                                                </td>

                                                            </tr>
                                                        </table>
                                                    </td>
                                                    <td style={{ width: "13%" }}></td>
                                                    <td style={{ width: "37%" }}></td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <label htmlFor="dt_Created" style={{ float: "right" }}>Date <span style={{ "color": "red" }}>*</span></label>
                                                    </td>
                                                    <td>
                                                        <input type="date" className="form-control" name="dt_Created" value={formData.dt_Created} onChange={handleFieldChange} />
                                                        <input type="hidden" className="form-control" name="AssignUserID" value={formData.AssignUserID} onChange={handleFieldChange} />
                                                        {errors.dt_Created && <div style={{ color: 'red' }}>{errors.dt_Created}</div>}
                                                    </td>

                                                    {(formData.snt_CommunicationType === "2" || formData.snt_CommunicationType === "3") && (
                                                        <td colSpan={2}>
                                                            <button type="button" style={{ padding: "5px 9px" }} className="btn btn-info" onClick={() => setShowDiaryModal(true)}>
                                                                Check Availablity
                                                            </button>
                                                        </td>
                                                    )}



                                                    {(formData.snt_CommunicationType === "0") && (
                                                        <>
                                                            <td>
                                                                <label htmlFor="dec_Weight" style={{ float: "right" }}>Assign To &nbsp;&nbsp;</label>
                                                            </td>
                                                            <td>

                                                                <select name="AssignUserID" className='form-control' value={formData.AssignUserID} onChange={handleFieldChange}>
                                                                    <option value="0">Assign To</option>
                                                                    {userList.map((user) => (
                                                                        <option key={user.UserID} value={user.UserID}>
                                                                            {user.DisplayName}
                                                                        </option>
                                                                    ))}
                                                                </select>

                                                            </td>
                                                        </>
                                                    )}

                                                </tr>
                                                <tr>
                                                    <td>
                                                        <label htmlFor="dt_Created" style={{ float: "right" }}>Telephone &nbsp;&nbsp;</label>
                                                    </td>
                                                    <td>
                                                        <table style={{ width: "100%" }}>
                                                            <tr>
                                                                <td>
                                                                    <input type="text" className="form-control" name="Phone" value={Phone} readOnly />
                                                                </td>
                                                                <td>
                                                                    {(LeadID > 0) && (Phone != "" && Phone != null && Phone != "undefined") && (
                                                                        <a href={`tel:${Phone}`} onClick={(e) => e.stopPropagation()}>
                                                                            <img src="assets/img/resources/phone.jpeg" alt="Add icon" style={{ height: "22px" }} />
                                                                        </a>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </td>
                                                    <td>
                                                        <label htmlFor="dt_Created" style={{ float: "right" }}>Mobile &nbsp;&nbsp;</label>
                                                    </td>
                                                    <td>
                                                        <table style={{ width: "100%" }}>
                                                            <tr>
                                                                <td>
                                                                    <input type="text" className="form-control" name="Mobile" value={Mobile} readOnly />
                                                                </td>
                                                                <td>
                                                                    {(LeadID > 0) && (Mobile != "" && Mobile != null && Mobile != "undefined") && (
                                                                        <a href={`tel:${Mobile}`} onClick={(e) => e.stopPropagation()}>
                                                                            <img src="assets/img/resources/phone.jpeg" alt="Add icon" style={{ height: "22px" }} />
                                                                        </a>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </td>
                                                </tr>







                                                {(formData.snt_CommunicationType === "2") && (
                                                    <tr>
                                                        <td style={{ width: "13%" }}>
                                                            <label htmlFor="DueDate" style={{ float: "right" }}>Due Date <span style={{ "color": "red" }}>*</span></label>
                                                        </td>
                                                        <td style={{ width: "37%" }}>
                                                            <input type="date" className="form-control" name="DueDate" value={formData.DueDate} onChange={handleFieldChange} />
                                                            {errors.DueDate && <div style={{ color: 'red' }}>{errors.DueDate}</div>}
                                                        </td>
                                                        <td style={{ width: "13%" }}>
                                                            <label htmlFor="Time" style={{ float: "right" }}>Time <span style={{ "color": "red" }}>*</span></label>
                                                        </td>
                                                        <td style={{ width: "37%" }}>
                                                            <input type="time" className="form-control" name="DueTime" value={formData.DueTime} onChange={handleFieldChange} />
                                                            {errors.DueTime && <div style={{ color: 'red' }}>{errors.DueTime}</div>}
                                                        </td>
                                                    </tr>
                                                )}


                                                {formData.snt_CommunicationType === "3" && (
                                                    <>
                                                        <tr>
                                                            <td style={{ width: "13%" }}>
                                                                <label htmlFor="Time" style={{ float: "right" }}>Start Time <span style={{ "color": "red" }}>*</span></label>
                                                            </td>
                                                            <td style={{ width: "37%" }}>
                                                                <input type="time" className="form-control" name="StartTime" value={formData.StartTime} onChange={handleFieldChange} />
                                                                {errors.StartTime && <div style={{ color: 'red' }}>{errors.StartTime}</div>}
                                                            </td>
                                                            <td style={{ width: "13%" }}>
                                                                <label htmlFor="AppointmentDate" style={{ float: "right" }}>Due Date <span style={{ "color": "red" }}>*</span></label>
                                                            </td>
                                                            <td style={{ width: "37%" }}>
                                                                <input type="date" className="form-control" name="AppointmentDate" value={formData.AppointmentDate} onChange={handleFieldChange} />
                                                                {errors.AppointmentDate && <div style={{ color: 'red' }}>{errors.AppointmentDate}</div>}
                                                            </td>

                                                        </tr>
                                                        <tr>
                                                            <td style={{ width: "13%" }}>
                                                                <label htmlFor="Time" style={{ float: "right" }}>End Time <span style={{ "color": "red" }}>*</span></label>
                                                            </td>
                                                            <td style={{ width: "37%" }}>
                                                                <input type="time" className="form-control" name="AppointmentEndTime" value={formData.AppointmentEndTime} onChange={handleFieldChange} />
                                                                {errors.AppointmentEndTime && <div style={{ color: 'red' }}>{errors.AppointmentEndTime}</div>}
                                                            </td>
                                                            <td></td>
                                                            <td></td>

                                                        </tr>


                                                    </>
                                                )}
                                                {(formData.snt_CommunicationType === "2" || formData.snt_CommunicationType === "3") && (
                                                    <tr>
                                                        <td style={{ width: "13%" }}>
                                                            <label htmlFor="Status" style={{ float: "right" }}>Status <span style={{ "color": "red" }}>*</span></label>
                                                        </td>
                                                        <td style={{ width: "37%" }}>
                                                            <select name="Status" className='form-control' value={formData.Status} onChange={handleFieldChange}>
                                                                <option value="0">Pending</option>
                                                                <option value="1">Completed</option>
                                                            </select>
                                                        </td>
                                                        <td></td>
                                                        <td></td>

                                                    </tr>
                                                )}
                                                {formData.snt_CommunicationType === "1" && (
                                                    <>
                                                        <tr>
                                                            <td style={{ width: "13%" }}>
                                                                <label htmlFor="vc_From" style={{ float: "right" }}>From &nbsp;&nbsp;</label>
                                                            </td>
                                                            <td style={{ width: "37%" }}>
                                                                <input type="text" className="form-control" name="vc_From" value={formData.vc_From} onChange={handleFieldChange} disabled={formData.snt_CommunicationType === '0'} />
                                                                {errors.vc_From && <div style={{ color: 'red' }}>{errors.vc_From}</div>}
                                                            </td>
                                                            <td></td>
                                                            <td></td>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ width: "13%" }}>
                                                                <label htmlFor="vc_To" style={{ float: "right" }}>To &nbsp;&nbsp;</label>
                                                            </td>
                                                            <td style={{ width: "37%" }}>
                                                                <input type="text" className="form-control" name="vc_To" value={formData.vc_To} onChange={handleFieldChange} disabled={formData.snt_CommunicationType === '0'} />
                                                                {errors.vc_To && <div style={{ color: 'red' }}>{errors.vc_To}</div>}
                                                            </td>
                                                            <td></td>
                                                            <td></td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <label htmlFor="vc_CC" style={{ float: "right" }}>CC &nbsp;&nbsp;</label>
                                                            </td>
                                                            <td>
                                                                <input type="text" className="form-control" name="vc_CC" value={formData.vc_CC} onChange={handleFieldChange} disabled={formData.snt_CommunicationType === '0'} />
                                                                {errors.vc_CC && <div style={{ color: 'red' }}>{errors.vc_CC}</div>}
                                                            </td>
                                                            <td></td>
                                                            <td></td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <label htmlFor="vc_Subject" style={{ float: "right" }}>Subject &nbsp;&nbsp;</label>
                                                            </td>
                                                            <td>
                                                                <input type="text" className="form-control" name="vc_Subject" value={formData.vc_Subject} onChange={handleFieldChange} />
                                                                {errors.vc_Subject && <div style={{ color: 'red' }}>{errors.vc_Subject}</div>}
                                                            </td>
                                                            <td></td>
                                                            <td></td>
                                                        </tr>


                                                    </>
                                                )}
                                                {(formData.snt_CommunicationType === "0" || formData.snt_CommunicationType === "1") && (
                                                    <>
                                                        <tr>
                                                            <td>
                                                                <label htmlFor="Name" style={{ float: "right" }}>Company Docs  &nbsp;&nbsp;</label>
                                                            </td>
                                                            <td>
                                                                <select name="CompanyDocument" className='form-control' value={formData.CompanyDocument} onChange={handleFieldChange}>
                                                                    <option value="0">New Document</option>
                                                                    {DocuemntList.map((document) => (
                                                                        <option key={document.ID} value={document.ID}>
                                                                            {document.DocumentName}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </td>
                                                            <td></td>
                                                            <td></td>

                                                        </tr>
                                                        {(formData.CompanyDocument.toString() === "0" &&
                                                            <tr>
                                                                <td style={{ width: "13%" }}>
                                                                    <label htmlFor="Path" style={{ float: "right" }}>Attach File </label>
                                                                </td>

                                                                <td style={{ width: "87%" }} colSpan={3}>
                                                                    <div
                                                                        {...getRootProps()}
                                                                        style={{
                                                                            border: '2px dashed #ccc',
                                                                            padding: '20px',
                                                                            borderRadius: '6px',
                                                                            textAlign: 'center',
                                                                            backgroundColor: isDragActive ? '#e6f7ff' : '#ffffff',
                                                                            cursor: 'pointer'
                                                                        }}
                                                                    >
                                                                        <input {...getInputProps()} />
                                                                        {
                                                                            formData.Path
                                                                                ? <p>{formData.Path}</p>
                                                                                : <p>Drag & drop a file here, or click to select</p>
                                                                        }
                                                                    </div>
                                                                    {errors.Path && <div style={{ color: 'red' }}>{errors.Path}</div>}

                                                                </td>
                                                            </tr>
                                                        )}
                                                    </>
                                                )}
                                                {pdfAttachment && (
                                                    <tr>
                                                        <td>
                                                            <label style={{ float: "right" }}>Attachment&nbsp;&nbsp;</label>
                                                        </td>
                                                        <td>
                                                            <a
                                                                href={pdfAttachment.url}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="btn btn-link btn-sm"
                                                            >
                                                                {pdfAttachment.name}
                                                            </a>
                                                        </td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                )}
                                                <tr>
                                                    <td style={{ width: "13%" }}>
                                                        <label htmlFor="vc_Description" style={{ float: "right" }}>Description <span style={{ "color": "red" }}>*</span></label>
                                                    </td>
                                                    <td colSpan={3} style={{ width: "87%" }}>

                                                        <SunTextEditor
                                                            value={formData.vc_Description.replace(/\n/g, '<br/>')}
                                                            onChange={(content) =>
                                                                setFormData((prev) => ({
                                                                    ...prev,
                                                                    vc_Description: content,
                                                                }))
                                                            }
                                                        />
                                                        {errors.vc_Description && (
                                                            <div style={{ color: 'red' }}>{errors.vc_Description}</div>
                                                        )}
                                                    </td>

                                                </tr>
                                                {formData.snt_CommunicationType === "1" && (
                                                    <tr>
                                                        <td>

                                                        </td>
                                                        <td>
                                                            <button
                                                                type="button"
                                                                className="btn btn-info"
                                                                onClick={() => {
                                                                    if (!formData.vc_Description) {
                                                                        alert("Please enter some content before preview.");
                                                                        return;
                                                                    }
                                                                    setShowEmailPreview(true);
                                                                }}
                                                            >
                                                                Preview Email
                                                            </button>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    {formData.snt_CommunicationType === "1" && (
                                        <button type="submit"
                                            className="btn btn-success"
                                            disabled={loading}
                                            onClick={() => setFormData({ ...formData, IsEmailSend: "1" })}
                                        >
                                            <i class="icofont-send-mail"></i>  Send
                                        </button>
                                    )}
                                    <button type="submit"
                                        className="btn btn-primary"
                                        disabled={loading}
                                        onClick={() => setFormData({ ...formData, IsEmailSend: "0" })}
                                    >
                                        <img src="assets/img/resources/update-icon.png" alt="Add icon" style={{ height: "10px" }} />  Save
                                    </button>
                                    <button className="btn btn-danger" type="button" aria-label="Close" onClick={onClose}>
                                        <img src="assets/img/resources/close-button-icon.png" alt="Add icon" style={{ height: "10px" }} /> Close
                                    </button>
                                </div>
                            </div>
                        </Draggable>

                    </div>
                </div>
            </form>
            {(showEmailPreview &&
                <EmailPreviewModal

                    onClose={() => setShowEmailPreview(false)}
                    subject={formData.vc_Subject}
                    description={formData.vc_Description}
                    footer={formData.EmailFooter}
                    to={formData.vc_To}
                    cc={formData.vc_CC}
                />
            )}
            {(showDiaryModal &&
                <LeadDiariesModal close={() => setShowDiaryModal(false)} onSuccess={handleSuccess} />
            )}
        </div>
    );
}
export default CreateCommunication;
